<template>
  <div v-if="lead">
    <card class="card" title="Dados do Lead (assinante)">
      <div>
        <form @submit.prevent="submit">
          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Nome"
                @keyup.native="toUpperName"
                required
                v-model="lead.name"
              ></fg-input>
            </div>
            <div class="col-md-2">
              <fg-input
                type="text"
                label="CPF"
                v-mask="'##############'"
                required
                v-model="lead.taxId"
              ></fg-input>
            </div>
            <div class="col-md-3">
              <fg-input
                type="date"
                label="Data de Nasc."
                v-model="lead.birthDate"
                required
              ></fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Nome da Mãe"
                @keyup.native="toUpperMotherName"
                v-model="lead.motherName"
              ></fg-input>
            </div>
            <div class="col-md-3">
              <fg-input
                type="text"
                label="E-mail Financeiro"
                @keyup.native="toUpperEmail"
                required
                v-model="lead.email"
              ></fg-input>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="exampleFormControlTextarea1">Gênero</label>
                <select
                  class="form-control input i-width"
                  v-model="lead.gender"
                  required
                >
                  <option :value="null" selected disabled>Selecione...</option>
                  <option value="1">Masculino</option>
                  <option value="2">Feminino</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <fg-input
                type="text"
                label="R.G /I.E"
                @keyup.native="toUpperRG"
                required
                v-model="lead.rg"
              ></fg-input>
            </div>
            <div class="col-md-3">
              <fg-input
                type="text"
                label="Orgão Exp. RG"
                @keyup.native="toExpSliced"
                required
                v-model="lead.orgaoRG"
              ></fg-input>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="exampleFormControlTextarea1"
                  >Tipo de Assinante</label
                >
                <select
                  class="form-control input i-width"
                  v-model="lead.subscriberType"
                  required
                >
                  <option :value="null" selected disabled>Selecione...</option>
                  <option
                    v-for="f in field.subscriberTypes"
                    :key="f.id"
                    :value="f.id"
                  >
                    {{ f.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <fg-input
                type="text"
                label="Celular"
                v-mask="'(##)#########'"
                required
                v-model="lead.commercialPhone"
              ></fg-input>
            </div>
            <div class="col-md-3">
              <fg-input
                type="text"
                label="Telefone residential"
                v-mask="'(##)#########'"
                required
                v-model="lead.residentialPhone"
              ></fg-input>
            </div>
            <div class="col-md-3">
              <fg-input
                type="text"
                label="Telefone comercial"
                v-mask="'(##)#########'"
                required
                v-model="lead.phone"
              ></fg-input>
            </div>
          </div>

          <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label for="exampleFormControlTextarea1">Origem</label>
              <select class="form-control input i-width" v-model="lead.origin" required>
                <option :value="null" selected disabled>Selecione...</option>
                <option value="dashboard">Plataforma (Interno)</option>
                <option value="seller">Vendedor Externo</option>
              </select>
            </div>
          </div>
        </div>

          <hr>
          <br />
          <span>Endereço do assinante</span>
          <div class="row">
            <div class="col-md-3">
              <fg-input
                type=""
                label="CEP"
                v-mask="'########'"
                required
                v-model="lead.zipCode"
                @blur="fetchCEP"
              ></fg-input>
            </div>

            <div class="col-md-6">
              <fg-input
                type="text"
                label="Endereço"
                @keyup.native="toUpperAddress"
                required
                v-model="lead.address"
              ></fg-input>
            </div>
            <div class="col-md-2">
              <fg-input
                type="text"
                label="Número"
                required
                v-model="lead.addressNumber"
              ></fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Estado(UF)"
                placeholder="Ex: SP"
                @keyup.native="toUpperState"
                v-model="lead.state"
              >
              </fg-input>
            </div>

            <div class="col-md-4">
              <fg-input
                type="text"
                label="Cidade"
                @keyup.native="toUpperCity"
                required
                v-model="lead.city"
              ></fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Bairro"
                @keyup.native="toUpperDistrict"
                required
                v-model="lead.district"
              ></fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-2">
              <fg-input
                type="text"
                label="Complemento"
                @keyup.native="toUpperAddressExtra"
                v-model="lead.addressExtra"
              ></fg-input>
            </div>
            <div class="col-md-2">
              <div class="form-group">
                <label for="exampleFormControlTextarea1">Área</label>
                <select
                  class="form-control input i-width"
                  v-model="lead.area"
                  required
                >
                  <option :value="null" selected disabled>Selecione...</option>
                  <option
                    v-for="f in field.subscriberAreas"
                    :key="f.id"
                    :value="f.id"
                  >
                    {{ f.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <hr>
          <br />
          <span>Plano e data do pedido</span>
          <div class="row">
            <div class="col-md-5">
              <div class="form-group">
                <label for="exampleFormControlTextarea1"
                  >Selecione o plano</label
                >
                <select
                  v-model="lead.planId"
                  class="form-control input i-width"
                  required
                >
                  <option :value="null" selected disabled>Selecione...</option>
                  <option
                    v-for="plan in plans"
                    :key="plan.planId"
                    :value="plan.planId"
                  >
                    {{ plan.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-md-4">
              <fg-input
                type="date"
                label="Data"
                v-model="lead.createdAt.split('T')[0]"
              ></fg-input>
            </div>
          </div>

          <hr>
          <br />
          <span>Outras informações</span>
          <div class="row">
            <div class="col-md-5">
              <div class="form-group">
                <label for="exampleFormControlTextarea1"
                  >Tipo de Contrato</label
                >
                <select
                  class="form-control input i-width"
                  v-model="lead.contractType"
                  required
                >
                  <option :value="null" selected disabled>Selecione...</option>
                  <option
                    v-for="f in field.contractTypes"
                    :key="f.id"
                    :value="f.id"
                  >
                    {{ f.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-md-5">
              <div class="form-group">
                <label for="exampleFormControlTextarea1"
                  >Carteira de Cobrança</label
                >
                <select
                  class="form-control input i-width"
                  v-model="lead.cartCob"
                  required
                >
                  <option :value="null" selected disabled>Selecione...</option>
                  <option v-for="f in field.cobCarts" :key="f.id" :value="f.id">
                    {{ f.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-5">
              <div class="form-group">
                <label for="exampleFormControlTextarea1">Vendedor</label>
                <select
                  class="form-control input i-width"
                  v-model="lead.seller"
                  required
                >
                  <option :value="null" selected disabled>Selecione...</option>
                  <option v-for="f in field.sellers" :key="f.id" :value="f.id">
                    {{ f.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="exampleFormControlTextarea1"
                  >Dia de Vencimento</label
                >
                <select
                  class="form-control input i-width"
                  v-model="lead.expirationDay"
                  required
                >
                  <option :value="null" selected disabled>Selecione...</option>
                  <option
                    v-for="f in field.expirationDates"
                    :key="f.id"
                    :value="f.id"
                  >
                    {{ f.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Mensagem</label>
                <textarea
                  rows="5"
                  class="form-control border-input"
                  v-model="lead.message"
                ></textarea>
              </div>
            </div>
          </div>

          <span>Informações do Lead</span>

          <div class="row">
            <div class="col-md-3">
              <fg-input
                type="text"
                label="Status do Lead"
                disabled
                :value="status"
              ></fg-input>
            </div>
            <div v-if="lead.rejectionReason" class="col-md-3">
              <fg-input
                type="text"
                label="Motivo"
                disabled
                :value="lead.rejectionReason"
              ></fg-input>
            </div>
            <div class="col-md-2" v-if="lead.approval && lead.approval.allowed">
              <fg-input
                type="text"
                label="Valor Instalação"
                :value="`R$${lead.approval.data.fee}`"
              ></fg-input>
            </div>
<!--            <div class="col-md-4" v-if="lead.approval && lead.approval.allowed">-->
<!--              <fg-input-->
<!--                type="text"-->
<!--                label="Método Pagamento"-->
<!--                :value="formatPaymentMethod(lead.approval.data.paymentMethod)"-->
<!--              ></fg-input>-->
<!--            </div>-->
          </div>

          <div class="clearfix"></div>

          <div class="container_buttons">

            <button class="btn-custom btn-salvar" name="update">
              Atualizar Dados
            </button>

            <button
              @click="getScore"
              type="button"
              class="btn-custom btn-analise"
            >
              Análise Crédito
            </button>
            <button
              class="btn-custom btn-gerenet"
              name="create"
              v-show="showRegisterButton || forceAllowCreation"
            >
              Cadastrar no Gerenet
            </button>
            <button
              type="button"
              @click="toggleCreation"
              v-show="['admin', 'supervisor'].includes(userRole)"
              class="btn-custom btn-salvar"
              style="margin-left: 10px;"
            >
              {{ forceAllowCreation ? 'Remover' : 'Liberar' }} cadastro (exceção)
            </button>
            <button
              @click="showModal"
              type="button"
              class="btn-custom btn-interesse"
            >
              Recusar
            </button>
          </div>
        </form>
      </div>
    </card>

    <modal name="modal" :adaptive="true" classes="modal-override">
      <p class="text-center mt-1 modal-title">Selecione o motivo</p>
      <hr />
      <form class="container" @submit.prevent="rejectLead">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="exampleFormControlTextarea2"
                >Motivo do não interesse</label
              >
              <select
                v-model="body.rejectionReason"
                class="form-control input i-width"
              >
                <option :value="null" selected disabled>Selecione...</option>
                <optgroup label="Não tem interesse">
                  <option value="Cotação">Cotação</option>
                  <option value="Somente Orçamento">Somente Orçamento</option>
                </optgroup>
                <optgroup label="Rejeição da empresa">
                  <option value="Inadimplência">Inadimplência</option>
                  <option value="Localização não atendida">Localização não atendida</option>
                  <option value="Já é assinante">Já é assinante</option>
                  <option value="Contratou em outro CPF">Contratou em outro CPF</option>
                  <option value="Lead Duplicado">Lead Duplicado</option>
                </optgroup>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label for="exampleFormControlTextarea1">Status</label>
            <select
              v-model="body.status"
              class="form-control input i-width"
            >
              <option :value="null" selected disabled>Selecione...</option>
              <option value="client_rejected">Recusado pelo cliente</option>
              <option value="server_rejected">Recusado pela empresa</option>
            </select>
          </div>
        </div>
        <div>
          <button class="btn-custom btn-salvar" style="margin-top: 20px" type>
            Salvar Lead
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </modal>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { formatDistance } from "date-fns";
import pt from "date-fns/locale/pt-BR";
import { mapActions } from "vuex";
import axios from "axios";

export default {
  name: "ViewLead",
  computed: {
    status() {
      if (!this.lead) return "pendente";
      switch (this.lead.status) {
        case "pending":
          return "pendente";
        case "accepted":
          return "aceito";
        case "client_rejected":
          return "cliente recusou";
        case "server_rejected":
          return "empresa recusou";
        default:
          return "pendente";
      }
    },
    userRole() {
      return this.$store.getters.user.role;
    },
    plans() {
      return this.$store.getters.plans;
    },
    field() {
      return this.$store.getters.leadFields;
    },
    forceAllowCreation() {
      return this.lead.forceAllowCreation;
    }
  },
  data() {
    return {
      lead: null,
      showRegisterButton: false,
      loading: false,
      body: {
        rejectionReason: null,
        status: null,
      },
    };
  },
  methods: {
    ...mapActions([
      "fetchLead",
      "processLead",
      "updateLead",
      "fetchPlans",
      "fetchScore",
      "createClient",
      "fetchLeadFields",
      "toggleForceAllowLeadCreation",
    ]),
    formatDate(date) {
      return formatDistance(date, new Date(), {
        locale: pt,
        addSuffix: true,
      });
    },
    formatPaymentMethod(method) {
      switch (method) {
        case "CardOrInvoiceUpTo5Days":
          return "Cartão ou boleto até 5 dias";
        case "UpTo2CardInstallmentsOrInvoiceUpTo5Days":
          return "2x no cartão ou boleto até 5 dias";
        case "UpTo2CardInstallmentsOrAdvancedPayment":
          return "2x no cartão ou pagamento adiantado";
      }
    },
    async toggleCreation() {
      try {
        this.lead.forceAllowCreation = await this.toggleForceAllowLeadCreation({ id: this.$route.params.id });
        if (this.lead.forceAllowCreation) {
          Swal.fire("Sucesso!", "Lead está liberado para cadastro (exceção) por 20 minutos", "success");
        } else {
          Swal.fire("Sucesso!", "Lead não está mais liberado para cadastro (exceção)", "success");
        }
      } catch (err) {
        Swal.fire("Ops!", "Não foi possível liberar o lead", "error");
      }
    },
    toUpperName(e) {
      this.lead.name = e.target.value.toUpperCase();
    },
    toUpperMotherName(e) {
      this.lead.motherName = e.target.value.toUpperCase();
    },
    toUpperRG(e) {
      this.lead.rg = e.target.value.toUpperCase();
    },
    toUpperEmail(e) {
      this.lead.email = e.target.value.toUpperCase();
    },
    toUpperCity(e) {
      this.lead.city = e.target.value.toUpperCase();
    },
    toUpperAddressExtra(e) {
      this.lead.addressExtra = e.target.value.toUpperCase();
    },
    toUpperAddress(e) {
      this.lead.address = e.target.value.toUpperCase();
    },
    toUpperState(e) {
      this.lead.state = e.target.value.toUpperCase().slice(0, 2);
    },
    toExpSliced(e) {
      this.lead.orgaoRG = e.target.value.toUpperCase().slice(0, 6);
    },
    toUpperDistrict(e) {
      this.lead.district = e.target.value.toUpperCase();
    },
    toUpperSubject(e) {
      this.lead.subject = e.target.value.toUpperCase();
    },
    showModal() {
      this.$modal.show("modal");
    },
    async fetchCEP(e) {
      const cep = e.target.value;
      try {
        const {data} = await axios.get(`https://brasilapi.com.br/api/cep/v2/${cep}`);
        this.lead.city = data.city;
        this.lead.address = data.street;
        this.lead.state = data.state;
        this.lead.district = data.neighborhood;
      } catch(err) {
        console.error("Could not get CEP", err);
      }
    },
    async getScore() {
      try {
        if (this.loading) {
          return;
        }
        this.loading = true;

        Swal.fire({
          title: "Analisando!",
          html: "Analisando crédito...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        const response = await this.fetchScore({ id: this.$route.params.id });
        Swal.close();

        if (response.allowed === false) {
          await Swal.fire(
            "Não aprovado!",
            "Esse lead não foi aprovado na análise de crédito",
            "warning"
          );
        } else {
          let text = `A taxa de instalação desse lead é de R$${response.fee}, pagamento no ato da instalação (preferencialmente técnico terceiro).`;
          if (response.fee === 0) {
            text = `Instalação gratuita (preferencialmente técnico interno).`;
          }
          Swal.fire({
            title: "Aprovado",
            icon: "success",
            text,
            showCloseButton: false,
            showCancelButton: false,
            cancelButtonText: "Fechar",
          });

          this.showRegisterButton = true;
        }
      } catch (er) {
        Swal.close();
        if (er.response && er.response.status === 422) {
          Swal.fire(
            "Ops!",
            "O CPF/CNPJ informado não é válido, verifique e tente novamente",
            "error"
          );
        } else {
          await Swal.fire(
            "Ops!",
            "Não foi possível analisar o crédito deste lead",
            "error"
          );
        }
      } finally {
        this.loading = false;
      }
    },
    async submit(e) {
      if (e.submitter.name === "update") {
        try {
          await this.updateLead({ id: this.$route.params.id, body: this.lead });
          Swal.fire("Sucesso!", "Lead atualizado com sucesso", "success");
          this.$router.push("/leads");
        } catch (err) {
          Swal.fire("Ops!", "Não foi possível atualizar o lead", "error");
        }
      } else if (e.submitter.name === "create") {
        try {
          await this.updateLead({
            id: this.$route.params.id,
            body: { ...this.lead, status: "accepted" },
          });
          const result = await this.createClient({ body: { ...this.lead, leadId: Number(this.$route.params.id) } });
          const { isConfirmed } = await Swal.fire({
            title: "Sucesso!",
            text: "Cliente cadastrado com sucesso, deseja cadastrar um ponto?",
            icon: "success",
            focusCancel: true,
            showCancelButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Cancelar",
          });
          if (isConfirmed) {
            this.$router.push(
              `/clientes/${result
                .split(";")[1]
                .replace(/[\r\n]/gm, "")}/cadastrar-ponto`
            );
          } else {
            this.$router.push("/clientes");
          }
        } catch (err) {
          if (err.response && err.response.status === 400) {
            Swal.fire(
              "Ops!",
              "Não foi possível cadastrar o cliente, verifique se os campos obrigatórios estão preenchidos",
              "error"
            );
          } else {
            Swal.fire("Ops!", "Não foi possível cadastrar o cliente", "error");
          }
        }
      }
    },
    async rejectLead() {
      try {
        await this.processLead({ id: this.$route.params.id, body: this.body });
        Swal.fire("Sucesso!", "Lead rejeitado com sucesso", "success");
        this.$router.push("/leads");
      } catch (err) {
        if (err && err.response && err.response.status === 409) {
          Swal.fire("Ops!", "Este lead ja foi processado", "error");
          return;
        }
        Swal.fire("Ops!", "Não foi possível rejeitar o lead", "error");
      }
    },
  },
  async mounted() {
    try {
      [this.lead] = await Promise.all([
        this.fetchLead({ id: this.$route.params.id }),
        this.fetchPlans(),
        this.fetchLeadFields(),
      ]);
      if (this.lead.approval && this.lead.approval.allowed) {
        this.showRegisterButton = true;
      }
    } catch (e) {
      Swal.fire("Ops!", "Não foi possível carregar o lead", "error");
    }
  },
};
</script>

<style lang="scss" scoped>
span {
  font-size: 22px;
  font-weight: bold;
}
.btn-custom {
  color: #f4f3ef;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 20px;
  transition: all 0.5s;

  &.btn-salvar {
    background: #9dcf6b;
    &:hover {
      background: #82ac58;
    }
  }

  &.btn-analise {
    margin-left: 10px;
    background: orange;
    &:hover {
      background: #c07e03;
    }
  }

  &.btn-gerenet {
    margin-left: 10px;
    background: #2c69c5;
    &:hover {
      background: #1e4e97;
    }
  }

  &.btn-interesse {
    margin-left: 10px;
    background: #b80a0a;
    &:hover {
      background: #700202;
    }
  }
}

@media (min-width: 768px) and (max-width: 1077px) {
  button.btn-custom.btn-interesse {
    margin-top: 20px !important;
  }
}

@media (max-width: 425px) {
  .modal-override {
    margin: auto;
    max-width: 400px;
    height: 385px !important;
  }
}
</style>
